import { useStorage } from './use-storage';

const Feature = {
  TRANSLATION: 'translation',
  PIX_PAYMENT: 'pix_payment',
  CARD_PAYMENT: 'card_payment',
  WALLET_PAYMENT: 'wallet_payment',
  ON_SITE: 'on_site',
  ON_SITE_TIP: 'on_site_tip',
  DELIVERY: 'delivery',
  MENU: 'menu',
  SELF_ORDERING: 'self_ordering',
};

const FeatureGroup = {
  PAYMENT: [Feature.PIX_PAYMENT],
};

function useFeature() {
  const { menuInfoRef } = useStorage();

  function isFeatureAvailable(feature) {
    switch (feature) {
      case Feature.TRANSLATION:
        return menuInfoRef.current?.i18n?.translation?.available === true;
      case Feature.PIX_PAYMENT:
        return menuInfoRef.current?.pay?.pix?.available === true;
      case Feature.CARD_PAYMENT:
        return menuInfoRef.current?.pay?.card?.available === true;
      case Feature.WALLET_PAYMENT:
        return menuInfoRef.current?.pay?.wallet?.available === true;
      case Feature.ON_SITE:
        return menuInfoRef.current?.on_site?.available === true;
      case Feature.ON_SITE_TIP:
        return menuInfoRef.current?.on_site?.available === true;
      case Feature.DELIVERY:
        return menuInfoRef.current?.delivery?.available === true;
      case Feature.MENU:
        return menuInfoRef.current?.available === true;
      case Feature.SELF_ORDERING:
        return (
          isFeatureAvailable(Feature.ON_SITE) ||
          isFeatureAvailable(Feature.DELIVERY)
        );
      default:
        return false;
    }
  }

  function isFeatureEnabled(feature) {
    if (!isFeatureAvailable(feature)) return false;

    switch (feature) {
      case Feature.TRANSLATION:
        return menuInfoRef.current?.i18n?.translation?.available === true;
      case Feature.PIX_PAYMENT:
        return menuInfoRef.current?.pay?.pix?.enabled === true;
      case Feature.CARD_PAYMENT:
        return menuInfoRef.current?.pay?.card?.enabled === true;
      case Feature.WALLET_PAYMENT:
        return menuInfoRef.current?.pay?.wallet?.enabled === true;
      case Feature.ON_SITE:
        return menuInfoRef.current?.on_site?.enabled === true;
      case Feature.ON_SITE_TIP:
        return menuInfoRef.current?.on_site?.tip?.enabled === true;
      case Feature.DELIVERY:
        return menuInfoRef.current?.delivery?.enabled === true;
      case Feature.MENU:
        return menuInfoRef.current?.available === true;
      case Feature.SELF_ORDERING:
        return (
          isFeatureEnabled(Feature.ON_SITE) ||
          isFeatureEnabled(Feature.DELIVERY)
        );
      default:
        return false;
    }
  }

  return { isFeatureAvailable, isFeatureEnabled };
}

export { Feature, FeatureGroup, useFeature };
